import React, { useState } from 'react';
import { Flex, FlexBehavior } from 'react-magma-dom';
import {
  StyledContainer,
  StyledFlexLeftSide,
  StyledFlexLoginForm,
  StyledPageContainer,
  StyledFindOutMoreButton,
} from '../../components/Styled/StyledLogin';
import { LeftSide } from './LeftSide';
import { LoginForm } from './LoginForm';
import { RouteComponentProps } from '@reach/router';
import { TermsOfUseModal } from '../../components/Modal';

export const Login: React.FC<RouteComponentProps> = (): JSX.Element => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  return (
    <StyledPageContainer>
      <StyledContainer>
        <Flex behavior={FlexBehavior.container} spacing={0}>
          <StyledFlexLeftSide behavior={FlexBehavior.item}>
            <LeftSide />
          </StyledFlexLeftSide>
          <StyledFlexLoginForm behavior={FlexBehavior.item}>
            <LoginForm setIsTermsOfUseModalOpened={setIsModalOpened} />
            <StyledFindOutMoreButton
              href="https://cengage.com.au/primary/browse-series/pm-writing"
              target="_blank"
              rel="noopener noreferrer"
            >
              Find out more
            </StyledFindOutMoreButton>
          </StyledFlexLoginForm>
        </Flex>
      </StyledContainer>
      {isModalOpened && (
        <TermsOfUseModal
          onClose={() => {
            setIsModalOpened(false);
          }}
        />
      )}
    </StyledPageContainer>
  );
};
